import axios from "axios";
import API from "../_helpers/endpointService";
export const getPCPActivity = (data) => {

  let apiUrl = API.LOOKUP_ACTIVITY;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "LOOKUP_PCPACT", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const getPCP_ListView = (data, id) => {
  let str = "";

  let apiUrl = API.PCP_LISTVIEW + '?projectId=' + id + '&Activity=' + data.Activity + '&FromDate=' + data.FromDate + '&ToDaTe=' + data.ToDaTe + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;

  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "PCPLIST_DOCS", data: response.data });
        }
        else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
      });
  };
};
export const addPCP = (data, formData) => {
  let apiUrl = API.PCP_LISTVIEW;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch(adduploadpbddocinfo(formData, response.data))
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const putpcpdocinfo = (data, formData, id, array) => {
  let apiUrl = API.PCP_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (array.length > 0) {
            dispatch(adduploadpbddocinfo(formData, id))
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const adduploadpbddocinfo = (data, id) => {
  let apiUrl = API.PCP_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const geteditpcpdocinfo = (id) => {
  let apiUrl = API.PCP_LISTVIEW + '/' + id
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "PCPEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const gethistorylogPCP = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=PreCutting'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const filedeletepcp = (id, name) => {
  let apiUrl = API.PCP_LISTVIEW + '/' + id + '?filename=' + name;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const deletemulitipcpdocs = (data, modify) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.PCP_LISTVIEW + '/ids?' + ids + '&modify=' + modify;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const deletePCP = (id, modify) => {
  let apiUrl = API.PCP_LISTVIEW + '/ids?ids=' + id + '&modify=' + modify;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
      data: id,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};